module.exports = __webpack_public_path__ + "img/sisda-logo.a6dfc16c.png";